import { render, staticRenderFns } from "./Contratacoes2.vue?vue&type=template&id=450b40ce"
import script from "./Contratacoes2.vue?vue&type=script&lang=js"
export * from "./Contratacoes2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports